/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRecruiting = (props: Props) => (
  <Icon viewBox="0 0 24 25" {...props}>
    <g fill="none">
      <path
        d="M12 4.55a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-5 3a5 5 0 1 1 10 0 5 5 0 0 1-10 0zm-.681 10.684C5.425 19.08 5 20.216 5 21.55v1H3v-1c0-1.782.583-3.481 1.944-4.769 1.35-1.275 3.351-2.042 5.996-2.2l.12 1.996c-2.338.14-3.836.8-4.741 1.657zM21 14.55h-6v3h-2v6h10v-6h-2v-3zm-2 3h-2v-1h2v1z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgRecruiting as Recruiting };
